/**
 * Operator Transformer - Filter operator transformation logic
 *
 * Transforms filter operators based on field type and entity context,
 * handling special cases for status fields and vulnerability queries.
 *
 * @module queryBuilderCore/transformers/operatorTransformer
 */

import { getStatusOperator } from '@/utils/mappings.util';

/**
 * Transforms filter operators based on field and entity type
 *
 * @param field - Field name being filtered
 * @param operator - Original operator
 * @param entityType - Type of entity (Asset, Vulnerability, Seed, etc.)
 * @param value - Filter value (used for status operator determination)
 * @returns Transformed operator appropriate for the field
 */
export function transformFilterOperator(
  field: string,
  operator: string,
  entityType: string,
  value: string | string[] | number | number[] | boolean | boolean[]
): string {
  if (field === 'status' && entityType === 'Vulnerability') {
    if (operator === '=' || operator === 'IN') {
      return 'STARTS WITH';
    } else if (operator === '!=' || operator === 'NOT IN') {
      return 'NOT STARTS WITH';
    }
  }

  if (field === 'status' && entityType === 'Seed') {
    if (operator === '=' || operator === 'IN') {
      return 'ENDS WITH';
    } else if (operator === '!=' || operator === 'NOT IN') {
      return 'NOT ENDS WITH';
    }
  }

  if (field === 'status') {
    return getStatusOperator(operator, Array.isArray(value));
  }

  return operator;
}
